import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { FeatBuild } from './FeatBuild';

const useStyles = makeStyles((theme) => ({
  paper: {
    // wide enough for the three trees side by side (3 x 330 + gaps + padding); they wrap on smaller windows
    width: 1080,
    maxWidth: 'calc(100vw - 32px)',
    background: 'linear-gradient(180deg, rgba(28, 29, 35, 0.99), rgba(18, 18, 22, 0.99))',
    border: '1px solid rgba(255, 255, 255, 0.09)',
    borderRadius: 14,
  },
  title: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    alignItems: 'center',
    paddingBottom: 0,
    '& h2': { fontWeight: 800 },
  },
  content: {
    paddingBottom: theme.spacing(2.5),
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  /** e.g. the player's name */
  title: string;
  spec: string | null | undefined;
}

/** A player's feat build in a dialog (game pages). */
export const FeatBuildDialog: React.FC<Props> = ({open, onClose, title, spec}) => {
  const classes = useStyles();
  return (
    // clicks inside the dialog would otherwise reach the row it was opened from (portals bubble through React)
    <Dialog open={open} onClose={onClose} maxWidth={false} classes={{paper: classes.paper}} onClick={(e) => e.stopPropagation()}>
      <DialogTitle disableTypography className={classes.title}>
        <h2 style={{margin: 0, fontSize: '1.2rem'}}>{title}</h2>
        <IconButton size="small" onClick={onClose}><Close /></IconButton>
      </DialogTitle>
      <DialogContent className={classes.content}>
        {open && <FeatBuild spec={spec} />}
      </DialogContent>
    </Dialog>
  );
};
